import React, { Fragment, useContext, useMemo } from 'react';
import { Popover, Transition } from '@headlessui/react';
import SearchIcon from 'icons/search';
import Quicksearch from '../../quicksearch';

const SearchButton = () => {
  return (
    <Popover>
      {({ open, close }) => (
        <>
          <Popover.Button>
            <div
              data-testid="mobile-header-search-button"
              className="flex flex-col items-center justify-center"
              aria-label="Search button"
            >
              <div className="size-5">
                <SearchIcon />
              </div>
            </div>
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Popover.Panel className="fixed inset-x-0 top-[--header-mobile-size]">
              <div data-testid="mobile-quicksearch-popup" className="w-full bg-white">
                <Quicksearch className="w-full" closeSearch={close} />
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default SearchButton;
